import { extractValues, mergeConfig } from '../utils/configUtils'
import { fontCheck } from '../utils/fontUtils'
import { getDownloadUrl } from '../utils/exportUtils'
import { getPatternByIndex } from '../utils/patternsUtils'
import LegendBehavior from '../viz_behaviors/LegendBehavior'

const cloneDeep = require('clone-deep')
class BaseComponent {
  get data() {
    return this._data
  }
  set data(value) {
    this._data = value
    this.viz.data = this.data
  }

  get config() {
    return this._config
  }
  set config(value) {
    let merged = mergeConfig(value, this._getConfig())
    let valid = extractValues(merged)
    this._config = valid
    this.viz.config = this.config
    this.viz.onAnnotationChange = this.onAnnotationChange
    this.viz.onAnnotationClick = this.onAnnotationClick
    this.viz.editMode = this.editMode
  }

  constructor($root, data, config) {
    this.$root = $root
    this.viz = new this.__proto__.constructor.vizClass(this.$root)
    this.viz._parent = this
    this.viz.componentLabel = this.__proto__.constructor.componentLabel || 'name_not_found' //this.constructor.name.replace('Component','')

    fontCheck().then(() => {
      // console.log("font is ready-------",document.fonts.check('1em santander'))
      // IMPORTANT, como metemos primero el "config" no se ejecutan dos draws seguidos [porque hay unos "if(!data) return" por ahi...]
      // this.config = config
      this.config = config
      if (data) this.data = data
      // if (this.onReady) this.onReady()
      this.emit('ready', { data: this.data, config: this.config })
    })
  }

  _getConfig() {
    let config = this.constructor.vizClass.prototype._getConfig()
    // estaba fatal, esto:
    // let result = mergeConfig(config, mergeConfig(this.__proto__.constructor.defaultConfig,this.constructor.defaultConfig))
    let result = mergeConfig(this.constructor.defaultConfig, config)
    return cloneDeep(result)
  }

  getSVG() {
    return this.viz.getSVG()
  }
  getSVGURL() {
    return this.getSVG().then(svg => {
      return getDownloadUrl(svg)
    })
  }

  on(eventName, callback) {
    this.addEventListener(eventName, callback)
  }
  addEventListener(eventName, callback) {
    this.eventListeners ||= {}
    this.eventListeners[eventName] ||= []
    this.eventListeners[eventName].push(callback)
  }
  emit(eventName, data) {
    //CUIDAO! me lo he cargado porqeu petaba el treemap, pero seguro se puede/debe recuperar!
    // data = data ? JSON.parse(JSON.stringify(data)) : undefined
    if (this.eventListeners) {
      this.eventListeners[eventName]?.forEach(cb => {
        cb(data)
      })
    }
    let onName = `on${eventName.charAt(0).toUpperCase() + eventName.slice(1)}`
    if (this[onName]) this[onName](data)
  }
  selectById(id) {
    this.viz && this.viz.selectById && this.viz.selectById(id)
  }
  showTooltipById(id) {
    this.viz && this.viz.showTooltipById && this.viz.showTooltipById(id)
  }

  static accessibilityRules = {
    altTitle: {
      id: 'altTitle',
      order: 1,
      label: 'rule_alt_title_label',
      description: 'rule_alt_title_desc',
      sidebarFieldName: 'altTitle',
      check: (config, data) => {
        return (
          !!config.AccessibilityBehavior.altTitle &&
          config.AccessibilityBehavior.altTitle !== config.title
        )
      },
    },
    altDesc: {
      id: 'altDesc',
      order: 2,
      label: 'rule_alt_desc_label',
      description: 'rule_alt_desc_desc',
      sidebarFieldName: 'altDesc',
      check: (config, data) => {
        return config.AccessibilityBehavior.altDesc
      },
    },
    textures: {
      id: 'textures',
      order: 3,
      label: 'rule_textures_label',
      description: 'rule_textures_desc',
      //sidebarFieldName: 'colorDict',
      exclude: (config, data) => !config.hasColorPatterns,
      check: (config, data) => {
        if (!config.hasColorPatterns) return true
        if (!config.LegendBehavior.showLegend) return false
        if (config.ItemsHelper.colorDict) {
          const colorKey =
            typeof config.ItemsHelper.colorKey === 'function' ? 'id' : config.ItemsHelper.colorKey
          const groupedDataKeys = new Set(data.map(d => d[colorKey]))
          let totalPatterns = [...groupedDataKeys].reduce((accumulator, current) => {
            accumulator += config.ItemsHelper.colorDict[current]?.pattern?.id ? 1 : 0
            return accumulator
          }, 0)
          return totalPatterns >= groupedDataKeys.size - 1
        }
        return false
      },
      applyAutoConfigChange: function (config, data, colors) {
        if (this.check(config, data)) return {}
        const oldConfig = {
          ItemsHelper: {
            ...config.ItemsHelper,
            colorDict: config.ItemsHelper.colorDict
              ? {
                  ...config.ItemsHelper.colorDict,
                }
              : undefined,
          },
          LegendBehavior: {
            ...config.LegendBehavior,
          },
        }
        const colorKey =
          typeof config.ItemsHelper.colorKey === 'function' ? 'id' : config.ItemsHelper.colorKey
        const groupedDataKeys = new Set(data.map(d => d[colorKey]))
        const newConfig = {
          ItemsHelper: {
            ...oldConfig.ItemsHelper,
            colorDict: [...groupedDataKeys].reduce((accumulator, current, i) => {
              accumulator[current] = {
                ...colors[current],
                pattern: getPatternByIndex(i),
              }
              return accumulator
            }, {}),
          },
          LegendBehavior: {
            showLegend: true,
          },
        }
        return {
          oldConfig,
          newConfig,
        }
      },
    },
    showLegend: {
      id: 'showLegend',
      order: 4,
      label: 'rule_show_legend_label',
      description: 'rule_show_legend_desc',
      sidebarFieldName: 'showLegend',
      exclude: (config, data) => {
        return (
          !['categorical', 'categorical2'].includes(config.ItemsHelper.colorScale) ||
          config.hasColorPatterns
        )
      },
      //LegendBehavior.showLegend
      /*
      check: (config, data) => {
        const MAX_DATA_COMPLEXITY = 8
        if (['categorical', 'categorical2'].includes(config.ItemsHelper.colorScale))
          return data.length <= MAX_DATA_COMPLEXITY
        return true
      },
      */
      check: (config, data) => {
        return config.LegendBehavior.showLegend
      },
      applyAutoConfigChange: function (config, data) {
        if (this.check(config, data)) return {}
        let newConfig = {
          LegendBehavior: {
            showLegend: true,
          },
        }
        return {
          oldConfig: {
            LegendBehavior: { ...config.LegendBehavior },
          },
          newConfig: newConfig,
        }
      },
    },
    chartComplexity: {
      id: 'chartComplexity',
      order: 5,
      label: 'rule_limit_chart_complexity_label',
      description: 'rule_limit_chart_complexity_desc',
      check: (config, data) => {
        const MAX_DATA_COMPLEXITY = 8
        if (['categorical', 'categorical2'].includes(config.ItemsHelper.colorScale))
          return data.length <= MAX_DATA_COMPLEXITY
        return true
      },
    },
  }
}

export default BaseComponent
